import React from 'react';
import '../less/zed.less';
import Banner from '../../../../../auxiliary-components/shared/Banner';
import banner_img from '../img/banner_img.png';
import usage_block_data from '../enums/usage_block_data.json';
import usage_block_data_2 from '../enums/usage_block_data_2.json';
import currency_exchange_block_data from '../enums/currency_exchange_block_data.json';
import currency_exchange_block_2_data from '../enums/currency_exchange_block_2_data.json';
import currency_exchange_advantages_data from '../enums/currency_exchange_advantages_data.json';
import currency_exchange_block_3_data from '../enums/currency_exchange_block_3_data.json';
import currency_exchange_conditions_data from '../enums/currency_exchange_conditions_data.json';
import currency_exchange_block_5_data from '../enums/currency_exchange_block_5_data.json';
import swift_advantages_data from '../enums/swift_advantages_data.json';
import swift_conditions_data from '../enums/swift_conditions_data.json';
import payoneer_advantages_data from '../enums/payoneer_advantages_data.json';
import sepa_advantages_data from '../enums/sepa_advantages_data.json';
import sepa_conditions_data from '../enums/sepa_conditions_data.json';
import UsageBlock from '../../../../../auxiliary-components/shared/UsageBlock';
import FilesForDownload from '../../../../../auxiliary-components/shared/FilesForDownload/views/file.c';
import { getUrl } from "utils/corploansUrl";
import purpose_img from "../img/purpose_img.png";
import BusinessOrder from "../../../../BusinessOrder";
import gov_img from "../img/gov_img.png";
import TabsNew from "../../../../../auxiliary-components/shared/TabsNew";
import Table from '../../../../../auxiliary-components/shared/Table';
import DOMPurify from 'utils/sanitize';
import clearBR from "utils/clearBR";

export default function template() {
    const isMobile = this.isViewportMobile(),
      modal = this.state.showModal ? <BusinessOrder attribute="ved-contract" closeModal={this.toggleModal} /> : '',
      modes = this.state.modes;

    // Общие компоненты для табов
    const commonMapAndFiles = (
        <>
            <div className='map'>
                <h2 className='map-title'>
                    {this.l10n('BUSINESS_GOV_PREVIEW_TITLE_2')}
                </h2>
                <div className='map-text'>
                    {this.l10n('BUSINESS_GOV_PREVIEW_TEXT_2')}
                </div>
                <button
                    className='map-btn'
                    onClick={() => window.open('/business/gov/eca', '_self')}
                >
                    {this.l10n('BUSINESS_GOV_PREVIEW_BTN_2')}
                </button>
                <img src={gov_img} alt='map_img' className='map-img' />
            </div>

            <FilesForDownload
                style={{marginBottom: 0}}
                lang={this.props.lang}
                widget={this.widgetsHelper.getWidget.call(
                    this,
                    'files_to_download'
                )}
            />
        </>
    );

    // Таблица для валютообміну
    const currencyExchangeTableData = {
        columns: [
            {
                column: 'BUSINESS_VED_CURRENCY_EXCHANGE_TABLE_HEADER_1',
                value: ['BUSINESS_VED_CURRENCY_EXCHANGE_TABLE_HEADER_2']
            },
            {
                column: 'BUSINESS_VED_CURRENCY_EXCHANGE_TABLE_ROW_1',
                value: ['BUSINESS_VED_CURRENCY_EXCHANGE_TABLE_ROW_2']
            }
        ]
    };

    // Таблица для SWIFT
    const swiftTableData = {
        columns: [
            {
                column: 'BUSINESS_VED_CURRENCY_EXCHANGE_TABLE_HEADER_1',
                value: ['BUSINESS_VED_CURRENCY_EXCHANGE_TABLE_HEADER_2']
            },
            {
                column: 'BUSINESS_VED_TRANSFERS_SWIFT_TABLE_ROW_1',
                value: ['BUSINESS_VED_TRANSFERS_SWIFT_TABLE_ROW_2']
            },
           {
                column: 'BUSINESS_VED_TRANSFERS_SWIFT_TABLE_ROW_3',
                value: ['BUSINESS_VED_TRANSFERS_SWIFT_TABLE_ROW_4']
            },
            {
                column: 'BUSINESS_VED_TRANSFERS_SWIFT_TABLE_ROW_5',
                value: ['BUSINESS_VED_TRANSFERS_SWIFT_TABLE_ROW_6']
            }
        ]
    };

    // Таблица для Payoneer
    const payoneerTableData = {
        columns: [
            {
                column: 'BUSINESS_VED_CURRENCY_EXCHANGE_TABLE_HEADER_1',
                value: ['BUSINESS_VED_CURRENCY_EXCHANGE_TABLE_HEADER_2']
            },
            {
                column: 'BUSINESS_VED_TRANSFERS_PAYONEER_TABLE_ROW_1',
                value: ['BUSINESS_VED_TRANSFERS_PAYONEER_TABLE_ROW_2']
            },
            {
                column: 'BUSINESS_VED_TRANSFERS_PAYONEER_TABLE_ROW_3',
                value: ['BUSINESS_VED_TRANSFERS_PAYONEER_TABLE_ROW_4']
            }
        ]
    };

    // Таблица для SEPA
    const sepaTableData = {
        columns: [
            {
                column: 'BUSINESS_VED_CURRENCY_EXCHANGE_TABLE_HEADER_1',
                value: ['BUSINESS_VED_CURRENCY_EXCHANGE_TABLE_HEADER_2']
            },
            {
                column: 'BUSINESS_VED_TRANSFERS_SEPA_TABLE_ROW_1',
                value: ['BUSINESS_VED_TRANSFERS_SEPA_TABLE_ROW_2']
            },
            {
                column: 'BUSINESS_VED_TRANSFERS_SEPA_TABLE_ROW_3',
                value: ['BUSINESS_VED_TRANSFERS_SEPA_TABLE_ROW_4']
            }
        ]
    };

    return (
        <div className='module-services'>
            <div className='zed-module'>
                <Banner
                    img={banner_img}
                    text={'BUSINESS_VED_BANNER_DESCRIPTIONS'}
                    textMob={'BUSINESS_VED_BANNER_DESCRIPTIONS'}
                    title={'BUSINESS_VED_BANNER_TITLE'}
                    toggleModal={this.toggleModal}
                    page={'aexpress'}
                    btnText={'BUSINESS_GET_CONSULT'}
                    isMobile={isMobile}
                ></Banner>
                <TabsNew
                    modes={modes}
                    mode={this.state.mode}
                    page={'quick-cash'}
                    isMobile={isMobile}
                    toggle={this.toggleMode}
                >
                    {/* Таб "Основна інформація" */}
                    <div className='wrapper' type={modes[0].mode}>
                        <div className='content'>
                            <div className='purpose-block'>
                                <div className='purpose-block-left-side'>
                                    <h2
                                        className='purpose-block-left-side-title'
                                        dangerouslySetInnerHTML={{
                                            __html: DOMPurify.sanitize(
                                                this.l10n('BUSINESS_VED_ADVANTAGES_TITLE')
                                            )
                                        }}
                                    ></h2>
                                    <div
                                        className='purpose-block-left-side-text'
                                        dangerouslySetInnerHTML={{
                                            __html: DOMPurify.sanitize(
                                                this.l10n('BUSINESS_VED_ADVANTAGES_DESCRIPTIONS')
                                            )
                                        }}
                                    ></div>
                                    <div
                                        className='purpose-block-left-side-title small'
                                        dangerouslySetInnerHTML={{
                                            __html: DOMPurify.sanitize(
                                                this.l10n(
                                                    'BUSINESS_VED_ADVANTAGES_DESCRIPTIONS_TITLE'
                                                )
                                            )
                                        }}
                                    ></div>
                                    <ul className='purpose-block-left-side-list'>
                                        <li
                                            className='purpose-block-left-side-list-item'
                                            dangerouslySetInnerHTML={{
                                                __html: DOMPurify.sanitize(
                                                    this.l10n(
                                                        'BUSINESS_VED_ADVANTAGES_DESCRIPTIONS_ITEM_1'
                                                    )
                                                )
                                            }}
                                        ></li>
                                        <li
                                            className='purpose-block-left-side-list-item'
                                            dangerouslySetInnerHTML={{
                                                __html: DOMPurify.sanitize(
                                                    this.l10n(
                                                        'BUSINESS_VED_ADVANTAGES_DESCRIPTIONS_ITEM_2'
                                                    )
                                                )
                                            }}
                                        ></li>
                                    </ul>
                                </div>
                                <div className='purpose-block-right-side'>
                                    <img
                                        src={purpose_img}
                                        alt='purpose_img'
                                        className='purpose-block-right-side-img'
                                    />
                                </div>
                            </div>
                            <UsageBlock
                                isMobile={isMobile}
                                page={'zed-3'}
                                data={usage_block_data}
                                className='col-3-row-1'
                                noTitle={true}
                                itemTitleTag={"div"}
                            ></UsageBlock>

                            <UsageBlock
                                isMobile={isMobile}
                                page={'zed'}
                                data={usage_block_data_2}
                                toggleModal={this.toggleModal}
                                className='col-3-row-1'
                                itemTitleTag={"div"}
                            ></UsageBlock>

                            {commonMapAndFiles}
                        </div>
                    </div>

                    {/* Таб "Перекази" */}
                    <div className='wrapper' type={modes[1].mode}>
                        <div className='content'>
                            <div className='transfers-subtabs'>
                                <button
                                    className={`transfers-subtab-btn ${
                                        this.state.transfersSubMode === 'swift' ? 'active' : ''
                                    }`}
                                    onClick={() => this.toggleTransfersSubMode('swift')}
                                >
                                    {this.l10n('BUSINESS_VED_TRANSFERS_NAV_SWIFT')}
                                </button>
                                <button
                                    className={`transfers-subtab-btn ${
                                        this.state.transfersSubMode === 'payoneer' ? 'active' : ''
                                    }`}
                                    onClick={() => this.toggleTransfersSubMode('payoneer')}
                                >
                                    {this.l10n('BUSINESS_VED_TRANSFERS_NAV_PAYONEER')}
                                </button>
                                <button
                                    className={`transfers-subtab-btn ${
                                        this.state.transfersSubMode === 'sepa' ? 'active' : ''
                                    }`}
                                    onClick={() => this.toggleTransfersSubMode('sepa')}
                                >
                                    {this.l10n('BUSINESS_VED_TRANSFERS_NAV_SEPA')}
                                </button>
                            </div>

                            {/* Підвкладка Swift */}
                            {this.state.transfersSubMode === 'swift' && (
                                <>
                                    <div className='mobilepay-whatIs'>
                                        <h2
                                            className='mobilepay-whatIs-title'
                                            dangerouslySetInnerHTML={{
                                                __html: DOMPurify.sanitize(
                                                    this.l10n('BUSINESS_VED_TRANSFERS_SWIFT_TITLE')
                                                )
                                            }}
                                        ></h2>
                                        <div
                                            className='mobilepay-whatIs-text'
                                            dangerouslySetInnerHTML={{
                                                __html: DOMPurify.sanitize(
                                                    this.l10n('BUSINESS_VED_TRANSFERS_SWIFT_TEXT')
                                                )
                                            }}
                                        ></div>
                                    </div>

                                    <UsageBlock
                                        isMobile={isMobile}
                                        page={'zed-3'}
                                        data={swift_advantages_data}
                                        className='col-2-row-1'
                                    ></UsageBlock>

                                    <div
                                        className='table-wrapper'
                                        style={{width: '815px', maxWidth: '100%', margin: '48px 0'}}
                                    >
                                        <h2 className={'block-title'}>
                                            {this.l10n('WELSEND_NEW_TARIFFS_TITLE')}
                                        </h2>
                                        <div className='general-table-divider'></div>
                                        <Table
                                            data={swiftTableData}
                                            page={'accepting-payments'}
                                            isMobile={isMobile}
                                        ></Table>
                                        <div
                                            className='disclaimer-text'
                                            dangerouslySetInnerHTML={{
                                                __html: isMobile
                                                    ? clearBR(
                                                          DOMPurify.sanitize(
                                                              this.l10n(
                                                                  'BUSINESS_VED_TRANSFERS_SWIFT_DISCLAIMER'
                                                              )
                                                          )
                                                      )
                                                    : DOMPurify.sanitize(
                                                          this.l10n(
                                                              'BUSINESS_VED_TRANSFERS_SWIFT_DISCLAIMER'
                                                          )
                                                      )
                                            }}
                                        ></div>
                                    </div>

                                    <UsageBlock
                                        isMobile={isMobile}
                                        page={'zed-3'}
                                        data={swift_conditions_data}
                                        className='col-2-row-1'
                                        noTitle={true}
                                    ></UsageBlock>

                                    <div className='moneygram-hint'>
                                        <div className='moneygram-hint-title'>
                                            <span className='danger-icon' />{' '}
                                            {this.l10n('BUSINESS_VED_TRANSFERS_SWIFT_HINT_TITLE')}
                                        </div>
                                        <div className='moneygram-hint-text'>
                                            {this.l10n('BUSINESS_VED_TRANSFERS_SWIFT_HINT_TEXT')}
                                        </div>
                                    </div>

                                    {commonMapAndFiles}
                                </>
                            )}

                            {/* Підвкладка Payoneer */}
                            {this.state.transfersSubMode === 'payoneer' && (
                                <>
                                    <UsageBlock
                                        isMobile={isMobile}
                                        page={'zed-3'}
                                        data={payoneer_advantages_data}
                                        className='col-3-row-1'
                                    ></UsageBlock>

                                    <div
                                        className='table-wrapper'
                                        style={{width: '815px', maxWidth: '100%'}}
                                    >
                                        <h2 className={'block-title'}>
                                            {this.l10n('CURRENCY_EXCHANGE_BLOCK_TITLE')}
                                        </h2>
                                        <div className='general-table-divider'></div>
                                        <Table
                                            data={payoneerTableData}
                                            page={'accepting-payments'}
                                            isMobile={isMobile}
                                        ></Table>
                                    </div>

                                    <div className='repayment-block'>
                                        <h2
                                            className='repayment-block-title'
                                            dangerouslySetInnerHTML={{
                                                __html: DOMPurify.sanitize(
                                                    this.l10n(
                                                        'BUSINESS_VED_TRANSFERS_PAYONEER_STEPS_TITLE'
                                                    )
                                                )
                                            }}
                                        ></h2>
                                        <ol className='numbered-list'>
                                            <li
                                                className='numbered-list-item'
                                                dangerouslySetInnerHTML={{
                                                    __html: DOMPurify.sanitize(
                                                        this.l10n(
                                                            'BUSINESS_VED_TRANSFERS_PAYONEER_STEP_1'
                                                        )
                                                    )
                                                }}
                                            ></li>
                                            <li
                                                className='numbered-list-item'
                                                dangerouslySetInnerHTML={{
                                                    __html: DOMPurify.sanitize(
                                                        this.l10n(
                                                            'BUSINESS_VED_TRANSFERS_PAYONEER_STEP_2'
                                                        )
                                                    )
                                                }}
                                            ></li>
                                            <li
                                                className='numbered-list-item'
                                                dangerouslySetInnerHTML={{
                                                    __html: DOMPurify.sanitize(
                                                        this.l10n(
                                                            'BUSINESS_VED_TRANSFERS_PAYONEER_STEP_3'
                                                        )
                                                    )
                                                }}
                                            ></li>
                                            <li
                                                className='numbered-list-item'
                                                dangerouslySetInnerHTML={{
                                                    __html: DOMPurify.sanitize(
                                                        this.l10n(
                                                            'BUSINESS_VED_TRANSFERS_PAYONEER_STEP_4'
                                                        )
                                                    )
                                                }}
                                            ></li>
                                            <li
                                                className='numbered-list-item'
                                                dangerouslySetInnerHTML={{
                                                    __html: DOMPurify.sanitize(
                                                        this.l10n(
                                                            'BUSINESS_VED_TRANSFERS_PAYONEER_STEP_5'
                                                        )
                                                    )
                                                }}
                                            ></li>
                                            <li
                                                className='numbered-list-item'
                                                dangerouslySetInnerHTML={{
                                                    __html: DOMPurify.sanitize(
                                                        this.l10n(
                                                            'BUSINESS_VED_TRANSFERS_PAYONEER_STEP_6'
                                                        )
                                                    )
                                                }}
                                            ></li>
                                            <li
                                                className='numbered-list-item'
                                                dangerouslySetInnerHTML={{
                                                    __html: DOMPurify.sanitize(
                                                        this.l10n(
                                                            'BUSINESS_VED_TRANSFERS_PAYONEER_STEP_7'
                                                        )
                                                    )
                                                }}
                                            ></li>
                                        </ol>
                                    </div>

                                    <div className='moneygram-hint'>
                                        <div className='moneygram-hint-title'>
                                            <span className='danger-icon' />{' '}
                                            {this.l10n(
                                                'BUSINESS_VED_TRANSFERS_PAYONEER_HINT_TITLE'
                                            )}
                                        </div>
                                        <div className='moneygram-hint-text'>
                                            {this.l10n('BUSINESS_VED_TRANSFERS_PAYONEER_HINT_TEXT')}
                                        </div>
                                    </div>

                                    {commonMapAndFiles}
                                </>
                            )}

                            {/* Підвкладка Sepa */}
                            {this.state.transfersSubMode === 'sepa' && (
                                <>
                                    <div className='mobilepay-whatIs'>
                                        <h2
                                            className='mobilepay-whatIs-title'
                                            dangerouslySetInnerHTML={{
                                                __html: DOMPurify.sanitize(
                                                    this.l10n('BUSINESS_VED_TRANSFERS_SEPA_TITLE')
                                                )
                                            }}
                                        ></h2>
                                        <div
                                            className='mobilepay-whatIs-text'
                                            dangerouslySetInnerHTML={{
                                                __html: DOMPurify.sanitize(
                                                    this.l10n('BUSINESS_VED_TRANSFERS_SEPA_TEXT')
                                                )
                                            }}
                                        ></div>
                                    </div>

                                    <UsageBlock
                                        isMobile={isMobile}
                                        page={'zed-3'}
                                        data={sepa_advantages_data}
                                        className='col-3-row-1'
                                    ></UsageBlock>

                                    <UsageBlock
                                        isMobile={isMobile}
                                        page={'zed-3'}
                                        data={sepa_conditions_data}
                                        className='col-2-row-1'
                                    ></UsageBlock>

                                    <div
                                        className='table-wrapper'
                                        style={{width: '815px', maxWidth: '100%', margin: '48px 0'}}
                                    >
                                        <div className='general-table-divider'></div>
                                        <Table
                                            data={sepaTableData}
                                            page={'accepting-payments'}
                                            isMobile={isMobile}
                                        ></Table>
                                    </div>

                                    <div className='repayment-block'>
                                        <h3
                                            className='repayment-block-title'
                                            dangerouslySetInnerHTML={{
                                                __html: DOMPurify.sanitize(
                                                    this.l10n(
                                                        'BUSINESS_VED_TRANSFERS_SEPA_REQUIREMENTS_TITLE'
                                                    )
                                                )
                                            }}
                                        ></h3>
                                        <ul className='special-list'>
                                            <li
                                                className='special-list-item'
                                                dangerouslySetInnerHTML={{
                                                    __html: DOMPurify.sanitize(
                                                        this.l10n(
                                                            'BUSINESS_VED_TRANSFERS_SEPA_REQUIREMENT_1'
                                                        )
                                                    )
                                                }}
                                            ></li>
                                            <li
                                                className='special-list-item'
                                                dangerouslySetInnerHTML={{
                                                    __html: DOMPurify.sanitize(
                                                        this.l10n(
                                                            'BUSINESS_VED_TRANSFERS_SEPA_REQUIREMENT_2'
                                                        )
                                                    )
                                                }}
                                            ></li>
                                        </ul>
                                    </div>

                                    {commonMapAndFiles}
                                </>
                            )}
                        </div>
                    </div>

                    {/* Таб "Обмін Валют" */}
                    <div className='wrapper' type={modes[2].mode}>
                        <div className='content'>
                            <div className='mobilepay-whatIs'>
                                <h2
                                    className='mobilepay-whatIs-title'
                                    dangerouslySetInnerHTML={{
                                        __html: DOMPurify.sanitize(
                                            this.l10n('BUSINESS_VED_CURRENCY_EXCHANGE_TITLE')
                                        )
                                    }}
                                ></h2>
                                <div
                                    className='mobilepay-whatIs-text'
                                    dangerouslySetInnerHTML={{
                                        __html: DOMPurify.sanitize(
                                            this.l10n('BUSINESS_VED_CURRENCY_EXCHANGE_TEXT')
                                        )
                                    }}
                                ></div>
                            </div>

                            <UsageBlock
                                isMobile={isMobile}
                                page={'zed-3'}
                                data={currency_exchange_block_data}
                                className='col-2-row-1'
                                noTitle={true}
                                itemTitleTag={"h3"}
                            ></UsageBlock>

                            <UsageBlock
                                isMobile={isMobile}
                                page={'zed-3'}
                                data={currency_exchange_block_3_data}
                                className='col-3-row-1'
                            ></UsageBlock>

                            <div
                                className='table-wrapper'
                                style={{width: '100%', maxWidth: '815px'}}
                            >
                                <h2 className={'block-title'}>
                                    {this.l10n('CURRENCY_EXCHANGE_BLOCK_TITLE')}
                                </h2>
                                <div className='general-table-divider'></div>
                                <Table
                                    data={currencyExchangeTableData}
                                    page={'accepting-payments'}
                                    isMobile={isMobile}
                                ></Table>
                                <div
                                    className='disclaimer-text'
                                    dangerouslySetInnerHTML={{
                                        __html: isMobile
                                            ? clearBR(
                                                  DOMPurify.sanitize(
                                                      this.l10n(
                                                          'BUSINESS_VED_CURRENCY_EXCHANGE_DISCLAIMER'
                                                      )
                                                  )
                                              )
                                            : DOMPurify.sanitize(
                                                  this.l10n(
                                                      'BUSINESS_VED_CURRENCY_EXCHANGE_DISCLAIMER'
                                                  )
                                              )
                                    }}
                                ></div>
                            </div>

                            <UsageBlock
                                isMobile={isMobile}
                                page={'zed-3'}
                                data={currency_exchange_block_5_data}
                                className='col-3-row-1'
                            ></UsageBlock>

                            {commonMapAndFiles}
                        </div>
                    </div>

                    {/* Таб "Корисні документи" */}
                    <div className='wrapper' type={modes[3].mode}>
                        <div className='content'>
                            <h2 className='block-title'>
                                {this.l10n('BUSINESS_VED_BLANC_TITLE')}
                            </h2>
                            <FilesForDownload
                                style={{marginBottom: 0}}
                                lang={this.props.lang}
                                widget={this.widgetsHelper.getWidget_2.call(
                                    this,
                                    'files_to_download'
                                )}
                                usefullDocsMode
                                titleTag={"h3"}
                            />
                            <FilesForDownload
                                style={{marginBottom: 0, paddingBottom: 0}}
                                lang={this.props.lang}
                                widget={this.widgetsHelper.getWidget_3.call(
                                    this,
                                    'files_to_download'
                                )}
                                usefullDocsMode
                                titleTag={"h3"}
                            />
                        </div>
                    </div>
                </TabsNew>
            </div>
            {modal}
        </div>
    );
}
